var ApiStat = function () {
    var MEAN = 200;
    var STD = 30;
    var FRAME = 10;


    var Service = function () {
        this.history = [];
    };


    Service.prototype.apiResponseTimeMs = function (value) {
        if (value == 0) return;
        this.history.push(value);
        if (this.history.length > FRAME) this.history.shift();

        if (this.history.length == FRAME) {
            MEAN = this.history.reduce(function (a, b) { return a + b; }, 0) / FRAME;
            STD = Math.sqrt(this.history
                .map(function (v) { return (v - MEAN) * (v - MEAN); })
                .reduce(function (a, b) { return a + b; }, 0) / FRAME);
        }

    };

    Service.prototype.getMean = function () {
        return MEAN;
    };

    Service.prototype.getSTD = function () {
        return STD;
    };


    return new Service();
};

ApiStat.$inject = [];

module.exports = ApiStat;